import { appendReduxPart } from "infrastructure/store";

import { tenantsSaga } from "./Tenant.saga";
import { tenants } from "./Tenant.slice";

export * from "./Tenant.actions";
export * from "./Tenant.state";

appendReduxPart(
  {
    reducerName: tenants.name,
    reducer: tenants.reducer
  },
  tenantsSaga()
);
